var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"map-wrapper"},[(!_vm.markers || _vm.markers.length == 0)?_c('div',[_c('p',[_vm._v("No se han encontrado sucursales")])]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }